import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon
  const [config, setConfig] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const [{ data: me }, { data: cfg }] = await Promise.all([api.get("/auth/me"), api.get("/config/active")]);
      setUser(me);
      setConfig(cfg);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem(TOKEN_KEY)) refresh();
    else setUser(false);
  }, [refresh]);

  const login = (token, u) => {
    localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
    api.get("/config/active").then((r) => setConfig(r.data));
  };
  const selectPracticeArea = (key) => { if (key && config?.key === key) return; api.get("/config/active", { params: key ? { key } : {} }).then((r) => setConfig(r.data)); };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };
  const can = (...perms) => !!user && (user.permissions?.includes("*") || perms.some((p) => user.permissions?.includes(p)));
  const roleLabel = config?.roles?.find((r) => r.key === user?.role)?.label || user?.role;

  return <Ctx.Provider value={{ user, config, login, logout, can, roleLabel, selectPracticeArea, refreshConfig: () => api.get("/config/active", { params: config?.key ? { key: config.key } : {} }).then((r) => setConfig(r.data)) }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
